import { OptimizelyMapper } from '@chegg-wt/core/hooks/useOimEventHandlers'

/* Each site / experience has a separate OIM campaign ID */
export const oimCampaignIdEB = {
  control: 'pk7caqnynohqkvazcg77',
  upload: 'feqlmfb1lxwxatcipmxp',
  auth: 'miwoow8mtgeklzo7n9xm',
}
export const oimCampaignIdCM = {
  control: 'e8xjmse9c2cxfiuqytke',
  upload: 'rtzrj6s8r7mjmb7lzojj',
  auth: 'q1lneh62em9gcerecy4f',
}

/* Each site has an Optimizely Web experiment, and each experiment has control / upload / auth variations */
export const optWebExpEB = {
  id: '18630493178',
  pageName: 'eb_viewpage_callback_trigger',
  controlVariationId: '18616442595',
  uploadVariationId: '18680490230',
  authVariationId: '18727510398',
}

export const optWebExpCM = {
  id: '18708400466',
  pageName: 'cm_viewpage_callback_trigger',
  controlVariationId: '18733040411',
  uploadVariationId: '18708520309',
  authVariationId: '18745040003',
}

const optimizelyMapper: OptimizelyMapper = (campaignId) => {
  const createBucketVisitor = (
    experimentId: string,
    variationId: string,
    pageName: string
  ) => ({
    optimizelyBucket: {
      type: 'bucketVisitor',
      experimentId,
      variationId,
    },
    optimizelyPage: {
      type: 'page',
      pageName,
    },
  })

  switch (campaignId) {
    case oimCampaignIdEB.control:
      return createBucketVisitor(
        optWebExpEB.id,
        optWebExpEB.controlVariationId,
        optWebExpEB.pageName
      )
    case oimCampaignIdEB.upload:
      return createBucketVisitor(
        optWebExpEB.id,
        optWebExpEB.uploadVariationId,
        optWebExpEB.pageName
      )
    case oimCampaignIdEB.auth:
      return createBucketVisitor(
        optWebExpEB.id,
        optWebExpEB.authVariationId,
        optWebExpEB.pageName
      )
    case oimCampaignIdCM.control:
      return createBucketVisitor(
        optWebExpCM.id,
        optWebExpCM.controlVariationId,
        optWebExpCM.pageName
      )
    case oimCampaignIdCM.upload:
      return createBucketVisitor(
        optWebExpCM.id,
        optWebExpCM.uploadVariationId,
        optWebExpCM.pageName
      )
    case oimCampaignIdCM.auth:
      return createBucketVisitor(
        optWebExpCM.id,
        optWebExpCM.authVariationId,
        optWebExpCM.pageName
      )
    default:
      return createBucketVisitor('n/a', 'n/a', 'n/a')
  }
}

export default optimizelyMapper
